import { useEffect, useState } from "react";

const KEY = "en-consent";
const MAX_AGE = 365 * 24 * 3600 * 1000;

export const readConsent = () => {
  try {
    const c = JSON.parse(localStorage.getItem(KEY));
    return c && c.v === 2 && Date.now() - c.ts < MAX_AGE ? c : null;
  } catch (e) {
    return null;
  }
};

export const saveConsent = ({ analytics, marketing }) => {
  const c = { analytics: !!analytics, marketing: !!marketing, ts: Date.now(), v: 2 };
  try {
    localStorage.setItem(KEY, JSON.stringify(c));
  } catch (e) {
    /* storage blocked */
  }
  window.dispatchEvent(new CustomEvent("en-consent", { detail: c }));
};

export const openCookieSettings = () => window.dispatchEvent(new Event("en-cookie-settings"));

export const useConsent = () => {
  const [consent, setConsent] = useState(readConsent);
  useEffect(() => {
    const on = (e) => setConsent(e.detail);
    window.addEventListener("en-consent", on);
    return () => window.removeEventListener("en-consent", on);
  }, []);
  return consent;
};
